export default __webpack_public_path__ + "static/assets/76911fb8f3dea25e9ed9b53db8b839c7.png";